import $ from 'jquery';
import './email-authentication';
import './projects-map';
import './catalog-search';
import * as bootstrap from 'bootstrap';
import GLightbox from 'glightbox';
import flatpickr from "flatpickr";

window.$ = $;
window.jQuery = $;
require('select2');

window.bootstrap = bootstrap;
window.GLightbox = GLightbox;
window.flatpickr = flatpickr;

window.applySelect2ToGasStationSelector = function () {
    $('.select2#projectGasStationId')
        .select2({
            dropdownParent: $('#createProjectModal'),
            placeholder: "--- Choose station ---",
        })
        .on('select2:select', function (e) {
            if (e.params.data.id == 'Create new' || e.params.data.id == 0) {
                $('#newGasStationFieldset').show();
            } else {
                $('#newGasStationFieldset').hide();
            }
        });
};

window.createStoreProject = function() {
    resetDuplicateMode();
    $('#createProjectModal').modal('show');
};

window.createBulkProject = function() {
    resetDuplicateMode();
    $('#createBulkProjectModal').modal('show');
};

window.resetDuplicateMode = function() {
    $('#createProjectModal').modal('hide');
    $('#duplicate_project_id').val('');
    $('#duplicate_bulk_project_id').val('');
    $('#duplicate-info').addClass('hidden');
    $('#duplicate-bulk-info').addClass('hidden');
    $('#modal-title-text').text('Create New Project');
    $('#modal-title-text-bulk').text('Create New Bulk Project');
    $('#submit-button-text').text('Save Project');
    $('#submit-button-text-bulk').text('Save Bulk Project');
};

window.setStoreDuplicateMode = function(projectId, projectName) {
    resetDuplicateMode();
    $('#duplicate_project_id').val(projectId);
    $('#duplicate-project-name').text(projectName);
    $('#duplicate-info').removeClass('hidden');
    $('#modal-title-text').text('Duplicate Project');
    $('#submit-button-text').text('Duplicate Project');
    $('#createProjectModal').modal('show');
};

window.setBulkDuplicateMode = function(projectId, projectName) {
    resetDuplicateMode();
    $('#duplicate_bulk_project_id').val(projectId);
    $('#duplicate-bulk-project-name').text(projectName);
    $('#duplicate-bulk-info').removeClass('hidden');
    $('#modal-title-text-bulk').text('Duplicate Bulk Project');
    $('#submit-button-text-bulk').text('Duplicate Bulk Project');
    $('#createBulkProjectModal').modal('show');
};

window.applySelect2ToOrderGasStationSelector = function () {
    $('.select2#gas-station-select')
        .select2({
            placeholder: "Select a store...",
            allowClear: true,
            width: '100%'
        });
};

applySelect2ToGasStationSelector();
applySelect2ToOrderGasStationSelector();

// Initialize GLightbox for images
function applyGLightbox() {
    const lightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: false,
        autoplayVideos: true
    });

    let elems = document.getElementsByClassName("popup-descr");

    [...elems].forEach(elem => GLightbox({
        selector: ".popup-descr-" + elem.getAttribute('data-id'),
        keyboardNavigation: false,
        touchNavigation: false,
    }));
}

window.addEventListener('DOMContentLoaded', applyGLightbox);
window.addEventListener('ajax:update-complete', applyGLightbox);

// Equipment Share functionality
function initializeEquipmentShare() {
    initializeEquipmentHandlers();
}

// Initialize equipment handlers
function initializeEquipmentHandlers() {
    // Product select handler
    $(document).on('click', '[data-create-advertisement-from-equipment]', function (e) {
        e.preventDefault();

        const equipmentUrl = $(this).data('create-advertisement-from-equipment');
        const $button = $(this);
        const $row = $button.closest('tr');
        const $cam = $('[data-advertisement-camera]');
        $cam.addClass('d-none');


        const equipmentId = equipmentUrl.match(/\/api\/equipment\/(\d+)/)?.[1];

        if (!equipmentId) {
            alert('Invalid equipment URL');
            return;
        }

        const productName = $row.find('[data-equipment-name]').text().trim();
        const productSize = $row.find('[data-equipment-size]').text().trim();

        $('[data-advertisement-equipment-id-input]').val(equipmentId);
        $('[data-advertisement-name-input]').val(productName);
        $('[data-advertisement-size-input]').val(productSize);
        $('[data-quantity-input]').val('');
        $('[data-advertisement-type][value="searching"]').prop('checked', true).trigger('change');

        const modal = document.querySelector('[data-modal="create-advertisement"]');
        const $submitBtn = $(modal).find('[data-form-submit]');
        const $successLink = $(modal).find('[data-form-success-link]');
        $submitBtn.removeClass('hidden');
        $successLink.addClass('d-none');

        if (modal) {
            modal.classList.remove('hidden');
            setTimeout(() => {
                $('[data-quantity-input]').focus();
            }, 100);
        } else {
            alert('Modal not found');
        }
    });

    $(document).on('click', '[data-open-create-advertisement]', function (e) {
        e.preventDefault();
        const modal = document.querySelector('[data-modal="create-advertisement"]');
        if (!modal) return;
        const $submitBtn = $(modal).find('[data-form-submit]');
        const $successLink = $(modal).find('[data-form-success-link]');
        $submitBtn.removeClass('hidden');
        $successLink.addClass('d-none');
        modal.classList.remove('hidden');
        $('[data-advertisement-type][value="searching"]').prop('checked', true).trigger('change');
        $('[data-advertisement-name-input]').focus();
        const $cam = $('[data-advertisement-camera]');
        $cam.removeClass('d-none');
        $cam.find('[data-advertisement-camera-input]').val('');
        const canvas = $cam.find('[data-advertisement-camera-image]')[0];
        if (canvas) {
            const ctx = canvas.getContext('2d');
            ctx && ctx.clearRect(0, 0, canvas.width || 0, canvas.height || 0);
        }
    });

    $(document).on('click', '[data-advertisement-camera-button]', function () {
        const $wrap = $(this).closest('[data-advertisement-camera]');
        $wrap.find('[data-advertisement-camera-input]').trigger('click');
    });

    $(document).on('change', '[data-advertisement-camera-input]', function (e) {
        const file = this.files && this.files[0];
        const $wrap = $(this).closest('[data-advertisement-camera]');
        const canvas = $wrap.find('[data-advertisement-camera-image]')[0];
        console.log('File:', file);
        console.log('Canvas:', canvas);
        if (!file || !canvas) return;
        const reader = new FileReader();
        reader.onload = function (ev) {
            const img = new Image();
            img.onload = function () {
                const ctx = canvas.getContext('2d');
                const maxW = 400;
                const scale = Math.min(1, maxW / img.width);
                const w = Math.floor(img.width * scale);
                const h = Math.floor(img.height * scale);
                canvas.width = w;
                canvas.height = h;
                ctx.drawImage(img, 0, 0, w, h);
                $(canvas).css({ display: 'block', width: '100%', height: 'auto' }).removeClass('hidden d-none');
                const $wrap = $(canvas).closest('[data-advertisement-camera]');
                $wrap.find('[data-advertisement-camera-remove]').css('display', 'inline-block').removeClass('hidden d-none');
                $wrap.find('[data-advertisement-camera-button]').css('display', 'none');
            };
            img.src = ev.target.result;
        };
        reader.readAsDataURL(file);
    });

    $(document).on('click', '[data-advertisement-camera-remove]', function () {
        const $wrap = $(this).closest('[data-advertisement-camera]');
        const input = $wrap.find('[data-advertisement-camera-input]')[0];
        const canvas = $wrap.find('[data-advertisement-camera-image]')[0];
        if (input) input.value = '';
        if (canvas) {
            const ctx = canvas.getContext('2d');
            ctx && ctx.clearRect(0, 0, canvas.width || 0, canvas.height || 0);
            canvas.width = 0;
            canvas.height = 0;
        }
        $(canvas).addClass('hidden').css('display', 'none');
        $wrap.find('[data-advertisement-camera-remove]').addClass('hidden').css('display', 'none');
        $wrap.find('[data-advertisement-camera-button]').css('display', 'block');
    });

    // Image zoom handler
    $(document).on('click', '[data-open-zoom-image]', function (e) {
        e.preventDefault();
        const apiUrl = $(this).data('open-zoom-image');
        const $button = $(this);

        $button.prop('disabled', true);

        $.ajax({
            url: apiUrl,
            type: 'GET',
            dataType: 'json',
            success: function (response) {
                let imageUrl = null;
                if (response && response.data && response.data.image) {
                    imageUrl = response.data.image;
                } else if (response && response.image) {
                    imageUrl = response.image;
                } else if (typeof response === 'string') {
                    imageUrl = response;
                }

                if (imageUrl) {
                    if (window.GLightbox) {
                        const lightbox = window.GLightbox({
                            elements: [{
                                href: imageUrl,
                                type: 'image'
                            }]
                        });
                        lightbox.open();
                    } else {
                        window.open(imageUrl, '_blank');
                    }
                } else {
                    console.error('No image URL found in response:', response);
                    alert('Could not load image');
                }
            },
            error: function () {
                console.error('Failed to fetch image data from:', apiUrl);
                alert('Failed to load image');
            },
            complete: function () {
                $button.prop('disabled', false);
            }
        });
    });

    // Offering / Searching action open modals
    $(document).on('click', '[data-offering-advertisement-from-equipment]', function (e) {
        e.preventDefault();
        const id = $(this).data('advertisement-id') || null;
        if (!id) return;
        const $modal = $('[data-modal="offering-advertisement"]');
        $modal.find('[data-advertisement-id-input]').val(id);
        $modal.removeClass('modal--hidden');
    });

    $(document).on('click', '[data-searching-advertisement-from-equipment]', function (e) {
        e.preventDefault();
        const id = $(this).data('advertisement-id') || null;
        if (!id) return;
        const $modal = $('[data-modal="searching-advertisement"]');
        $modal.find('[data-advertisement-id-input]').val(id);
        $modal.removeClass('modal--hidden');
    });

    $(document).on('submit', '[data-advertisement-offering-form], [data-advertisement-searching-form]', function (e) {
        e.preventDefault();
        const $form = $(this);
        const $submitBtn = $form.find('[data-form-submit]');
        const $errorDiv = $form.find('[data-form-error]');
        const $successDiv = $form.find('[data-form-success]');

        $submitBtn.prop('disabled', true).text('Submitting...');
        $errorDiv.empty();
        $successDiv.empty();

        const formData = new FormData(this);

        $.ajax({
            url: this.action,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function () {
                if ($form.data('sucess-redirect')) {
                    window.location.href = $form.data('sucess-redirect');
                } else {
                    $successDiv.html('Saved');
                    setTimeout(() => {
                        $form.closest('[data-modal]').addClass('modal--hidden');
                        location.reload();
                    }, 800);
                }
            },
            error: function (xhr) {
                let errorMessage = 'Error. Please try again.';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                } else if (xhr.responseJSON && xhr.responseJSON.errors) {
                    const errors = Object.values(xhr.responseJSON.errors).flat();
                    errorMessage = errors.join('<br>');
                } else if (xhr.responseText) {
                    errorMessage = xhr.responseText;
                } else if (xhr.statusText) {
                    errorMessage = xhr.statusText;
                }
                $errorDiv.html(errorMessage);
            },
            complete: function () {
                $submitBtn.prop('disabled', false).text('Confirm');
            }
        });
    });

    // Store info modal
    $(document).on('click', '[data-open-store-info]', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const name = $btn.data('store-name') || 'Store';
        const id = $btn.data('store-id') || '-';
        const address = $btn.data('store-address') || '-';
        const post = $btn.data('store-post-code') || '-';
        const city = $btn.data('store-city') || '-';
        const country = $btn.data('store-country') || '-';
        const contactPerson = $btn.data('contact-person');
        const contactPhone = $btn.data('contact-phone');

        const $modal = $('[data-modal="store-info"]');
        $modal.find('[data-store-title]').text(name);
        $modal.find('[data-store-field="id"]').text(id);
        $modal.find('[data-store-field="address"]').text(address);
        $modal.find('[data-store-field="post_code"]').text(post);
        $modal.find('[data-store-field="city"]').text(city);
        $modal.find('[data-store-field="country"]').text(country);
        if (contactPerson) {
            $modal.find('[data-store-field="contact_person"]').parent().removeClass('d-none');
            $modal.find('[data-store-field="contact_person"]').text(contactPerson);
        } else {
            $modal.find('[data-store-field="contact_person"]').parent().addClass('d-none');
        }
        if (contactPhone) {
            $modal.find('[data-store-field="contact_phone"]').parent().removeClass('d-none');
            $modal.find('[data-store-field="contact_phone"]').text(contactPhone);
        } else {
            $modal.find('[data-store-field="contact_phone"]').parent().addClass('d-none');
        }
        $modal.removeClass('modal--hidden');
    });

    // Shipment info modal
    $(document).on('click', '[data-open-shipment-info]', function (e) {
        e.preventDefault();
        const $button = $(this);
        const $modal = $('[data-modal="shipment-info"]');

        $modal.find('[data-shipment-date-display]').text($button.data('shipment-date') || 'N/A');
        $modal.find('[data-shipment-tracking-display]').text($button.data('shipment-tracking') || 'N/A');

        $modal.removeClass('modal--hidden');
    });

    $(document).on('click', '[data-open-shipping-for-order]', function (e) {
        e.preventDefault();
        const orderId = $(this).data('open-shipping-for-order');
        const $modal = $('[data-modal="shipping-advertisement"]');
        $modal.find('[data-order-id-input]').val(orderId);
        $modal.removeClass('modal--hidden');
    });

    // Submit shipping form via AJAX
    $(document).on('submit', '[data-advertisement-shipping-form]', function (e) {
        e.preventDefault();
        const $form = $(this);
        const $submitBtn = $form.find('[data-form-submit]');
        const $errorDiv = $form.find('[data-form-error]');
        const $successDiv = $form.find('[data-form-success]');

        $submitBtn.prop('disabled', true).text('Submitting...');
        $errorDiv.empty();
        $successDiv.empty();

        const formData = new FormData(this);

        $.ajax({
            url: this.action,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function () {
                location.reload();
            },
            error: function (xhr) {
                let errorMessage = 'Error. Please try again.';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                } else if (xhr.responseJSON && xhr.responseJSON.errors) {
                    const errors = Object.values(xhr.responseJSON.errors).flat();
                    errorMessage = errors.join('<br>');
                } else if (xhr.responseText) {
                    errorMessage = xhr.responseText;
                } else if (xhr.statusText) {
                    errorMessage = xhr.statusText;
                }
                $errorDiv.html(errorMessage);
            },
            complete: function () {
                $submitBtn.prop('disabled', false).text('Confirm');
            }
        });
    });

    // Modal close handlers
    $(document).on('click', '[data-modal-close]', function () {
        const modal = document.querySelector('[data-modal="create-advertisement"]');
        if (modal) {
            modal.classList.add('hidden');
        }
    });

    // Close modal when clicking outside
    $(document).on('click', '[data-modal="create-advertisement"]', function (e) {
        if (e.target === this) {
            this.classList.add('hidden');
        }
    });


    // Edit advertisement handler
    $(document).on('click', '[data-open-edit-advertisement]', function (e) {
        e.preventDefault();
        const advertisementId = $(this).data('open-edit-advertisement');
        $.get('/api/advertisement/' + advertisementId)
            .done(function (response) {
                if (response.data) {
                    const ad = response.data;

                    $('[data-modal="edit-advertisement"] [data-advertisement-id-input]').val(advertisementId);
                    $('[data-modal="edit-advertisement"] [data-advertisement-name-input]').val(ad.name || '');
                    $('[data-modal="edit-advertisement"] [data-advertisement-size-input]').val(ad.size || '');
                    $('[data-modal="edit-advertisement"] [data-quantity-input]').val(ad.quantity || '');

                    const $searchingFields = $('[data-modal="edit-advertisement"] [data-searching-fields]');
                    const $offeringFields = $('[data-modal="edit-advertisement"] [data-offering-fields]');

                    if (ad.type === 'searching') {
                        $searchingFields.removeClass('hidden');
                        $offeringFields.addClass('hidden');

                        $('[data-modal="edit-advertisement"] [data-delivery-store-id-input]').val(ad.delivery_store_id || '');
                        $('[data-modal="edit-advertisement"] [data-delivery-store-name-input]').val(ad.delivery_store_name || '');
                        $('[data-modal="edit-advertisement"] [data-delivery-city-input]').val(ad.delivery_city || '');
                        $('[data-modal="edit-advertisement"] [data-delivery-address-input]').val(ad.delivery_address || '');
                        $('[data-modal="edit-advertisement"] [data-delivery-post-code-input]').val(ad.delivery_post_code || '');
                        $('[data-modal="edit-advertisement"] [data-contact-person-input]').val(ad.contact_person || '');
                        $('[data-modal="edit-advertisement"] [data-contact-phone-input]').val(ad.contact_phone || '');
                    } else if (ad.type === 'offering') {
                        $searchingFields.addClass('hidden');
                        $offeringFields.removeClass('hidden');

                        $('[data-modal="edit-advertisement"] [data-book-value-input]').val(ad.book_value || '');
                        $('[data-modal="edit-advertisement"] [data-asset-number-input]').val(ad.asset_number || '');
                    }

                    const $cameraWrap = $('[data-modal="edit-advertisement"] [data-advertisement-camera]');
                    const $cameraButton = $cameraWrap.find('[data-advertisement-camera-button]');
                    const $cameraImage = $cameraWrap.find('[data-advertisement-camera-image]');
                    const $cameraRemove = $cameraWrap.find('[data-advertisement-camera-remove]');
                    const $cameraInput = $cameraWrap.find('[data-advertisement-camera-input]');

                    $cameraButton.css('display', 'block').removeClass('hidden d-none');
                    $cameraImage.css('display', 'none').addClass('hidden d-none');
                    $cameraRemove.css('display', 'none').addClass('hidden d-none');
                    $cameraInput.val('');

                    $cameraWrap.removeClass('d-none');

                    if (ad.photo) {
                        const img = new Image();
                        img.onload = function () {
                            const canvas = $cameraImage[0];
                            const ctx = canvas.getContext('2d');
                            const maxW = 400;
                            const scale = Math.min(1, maxW / img.width);
                            const w = Math.floor(img.width * scale);
                            const h = Math.floor(img.height * scale);
                            canvas.width = w;
                            canvas.height = h;
                            ctx.drawImage(img, 0, 0, w, h);
                            $cameraImage.css({ display: 'block', width: '100%', height: 'auto' }).removeClass('hidden d-none');
                            $cameraRemove.css('display', 'inline-block').removeClass('hidden d-none');
                            $cameraButton.css('display', 'none');
                        };
                        img.src = ad.photo;
                    }

                    $('[data-modal="edit-advertisement"]').removeClass('modal--hidden');
                } else {
                    console.error('Failed to load advertisement details');
                }
            })
            .fail(function () {
                console.error('Error fetching advertisement details');
            });
    });

    $(document).on('click', '[data-open-cancel-advertisement]', function (e) {
        e.preventDefault();
        const advertisementId = $(this).data('open-cancel-advertisement');

        $('[data-modal="cancel-advertisement"] [data-advertisement-id-input]').val(advertisementId);

        $('[data-modal="cancel-advertisement"]').removeClass('modal--hidden');
    });

    $(document).on('click', '[data-modal-close]', function () {
        const $modal = $(this).closest('[data-modal]');
        if ($modal.length) {
            if ($modal.hasClass('modal--hidden')) return;
            if ($modal.hasClass('hidden')) {
                $modal.addClass('hidden');
            } else {
                $modal.addClass('modal--hidden');
            }
        }
    });

    $(document).on('submit', '[data-advertisement-edit-form]', function (e) {
        e.preventDefault();
        const $form = $(this);
        const $submitBtn = $form.find('[data-form-submit]');
        const $errorDiv = $form.find('[data-form-error]');
        const $successDiv = $form.find('[data-form-success]');

        $submitBtn.prop('disabled', true).text('Updating...');
        $errorDiv.empty();
        $successDiv.empty();

        const formData = new FormData(this);

        $.ajax({
            url: this.action,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                location.reload();
            },
            error: function (xhr) {
                let errorMessage = 'Error updating advertisement. Please try again.';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                } else if (xhr.responseJSON && xhr.responseJSON.errors) {
                    const errors = Object.values(xhr.responseJSON.errors).flat();
                    errorMessage = errors.join('<br>');
                }
                $errorDiv.html(errorMessage);
            },
        });
    });

    $(document).on('submit', '[data-advertisement-cancel-form]', function (e) {
        e.preventDefault();
        const $form = $(this);
        const $submitBtn = $form.find('button[type="submit"]');
        const $cancelBtn = $form.find('button[data-modal-close]');
        const $errorDiv = $form.find('[data-form-error]');
        const $successDiv = $form.find('[data-form-success]');

        $submitBtn.prop('disabled', true).text('Cancelling...');
        $cancelBtn.prop('disabled', true);
        $cancelBtn.addClass('opacity-50');

        $errorDiv.empty();
        $successDiv.empty();

        const formData = new FormData(this);

        $.ajax({
            url: this.action,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                location.reload();
            },
            error: function (xhr) {
                let errorMessage = 'Error cancelling advertisement. Please try again.';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                } else if (xhr.responseJSON && xhr.responseJSON.errors) {
                    const errors = Object.values(xhr.responseJSON.errors).flat();
                    errorMessage = errors.join('<br>');
                }
                $errorDiv.html(errorMessage);
                $cancelBtn.removeClass('opacity-50');
                $cancelBtn.prop('disabled', false);
            },
            complete: function () {
            }
        });
    });

    $(document).on('submit', '[data-advertisement-create-form]', function (e) {
        e.preventDefault();
        const $form = $(this);
        const $submitBtn = $form.find('[data-form-submit]');
        const $errorDiv = $form.find('[data-form-error]');
        const $successDiv = $form.find('[data-form-success]');
        const $successLink = $form.find('[data-form-success-link]');

        $submitBtn.prop('disabled', true).text('Publishing...');
        $errorDiv.empty();
        $successDiv.empty();

        const formData = new FormData(this);

        $.ajax({
            url: this.action,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                $submitBtn.addClass('hidden');
                $successLink.removeClass('d-none');
                if (document.querySelector('[data-store-select]')) {
                    document.querySelector('[data-store-select]').value = '';
                }
                const storeSelect = $form.find('select[name="store_id"]');
                if (storeSelect.length) {
                    storeSelect.val('');
                }

                $form.find('input[name="delivery_store_name"]').val();
                $form.find('input[name="delivery_city"]').val('');
                $form.find('input[name="delivery_address"]').val('');
                $form.find('input[name="delivery_post_code"]').val('');
                $form.find('input[name="book_value"]').val('');
                $form.find('input[name="asset_number"]').val('');
                $form.find('input[name="contact_person"]').val('');
                $form.find('input[name="contact_phone"]').val('');
                $form.find('[data-new-delivery-fields]').addClass('hidden');
            },
            error: function (xhr) {
                let errorMessage = 'Error publishing advertisement. Please try again.';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                } else if (xhr.responseJSON && xhr.responseJSON.errors) {
                    const errors = Object.values(xhr.responseJSON.errors).flat();
                    errorMessage = errors.join('<br>');
                }
                $errorDiv.html(errorMessage);
            },
            complete: function () {
                $submitBtn.prop('disabled', false).text('Publish');
            }
        });
    });
}

function initializeDeliveryCalculationPolling() {
    const containers = document.querySelectorAll('[data-delivery-calculation-poll]');

    containers.forEach(container => {
        const orderId = container.getAttribute('data-order-id');
        console.log('orderId', orderId);
        if (!orderId) return;

        const valueElement = container.querySelector('[data-delivery-value]');
        console.log('valueElement', valueElement);
        if (!valueElement) return;

        let pollInterval = setInterval(function() {
            fetch(`/api/orders/${orderId}/delivery-calculation-status`)
                .then(response => response.json())
                .then(data => {
                    if (!data.is_calculating) {
                        clearInterval(pollInterval);

                        if (data.estimated_delivery_price) {
                            valueElement.innerHTML = data.estimated_delivery_price + ' EUR';
                        } else {
                            valueElement.innerHTML = '0.00 EUR';
                        }
                    }
                })
                .catch(error => {
                    console.error('Error polling delivery status:', error);
                    clearInterval(pollInterval);
                });
        }, 5000);
    });
}

// Initialize when DOM is ready
$(function () {
    initializeEquipmentShare();
    initializeDeliveryCalculationPolling();

    $(document).on('change', '[data-advertisement-type]', function () {
        const type = $('[data-advertisement-type]:checked').val();
        const $searching = $('[data-searching-fields]');
        const $offering = $('[data-offering-fields]');
        if (type === 'offering') {
            $searching.addClass('hidden');
            $offering.removeClass('hidden');
            $('[data-searching-required]').prop('required', false);
        } else {
            $offering.addClass('hidden');
            $searching.removeClass('hidden');
            $('[data-searching-required]').prop('required', true);
        }
    });

    // Toggle new delivery fields
    $(document).on('change', '[data-new-delivery-toggle]', function () {
        const checked = $(this).is(':checked');
        const $wrap = $('[data-new-delivery-fields]');
        if (checked) $wrap.removeClass('hidden'); else $wrap.addClass('hidden');
    });

    // Show new delivery fields when NEW store selected
    $(document).on('change', '[data-store-select]', function () {
        const val = $(this).val();
        const $wrap = $('[data-new-delivery-fields]');
        if (val === 'NEW') $wrap.removeClass('hidden'); else $wrap.addClass('hidden');
    });

    flatpickr("input[type='date']", {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "j F Y",
        weekNumbers: true,
        locale: {
            firstDayOfWeek: 1
        }
    });

    window.initDatePickers = function(selector) {
        flatpickr(selector, {
            dateFormat: "Y-m-d",
            altInput: true,
            altFormat: "j F Y",
            weekNumbers: true,
            locale: {
                firstDayOfWeek: 1
            }
        });
    };
});
